import React from 'react';
import { Paper, Typography } from '@mui/material';

const ChartCard = ({ title, children, color = "#152d51" }) => (
  <Paper sx={{ p: 4, borderRadius: 3, boxShadow: 5 }}>
    <Typography variant="h6" sx={{ color, fontWeight: "bold", mb: 2 }}>
      {title}
    </Typography>
    {children}
  </Paper>
);

export default ChartCard;